import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { fetchCurrentAccounts } from '../../../../actions/currentAccount/currentAccountList'
import CurrentAccounts from '../../CurrentAccounts'
import { AppState } from '../../../../reducers'
import { FiltersBar, Filters } from '../../../Utils/Filters/Filter'
import { FilterClientName } from '../../../Utils/Filters'
import { CurrentAccountListState } from '../../../../reducers/currentAccount/currentAccountList'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import CurrentAccount from '../../../../models/CurrentAccount'
import { SessionState, isAdmin, isHeadSales, isManager, isStaff, isVendor } from '../../../../reducers/auth/session'
import { roleToURLPrefix } from '../../../../App'
import { PERSON } from '../../../../models/User'
import { Stack } from '@mui/material'
import { receiptLegalTypes } from '../../../GeneralDesc'

interface Props {
  fullInfo?: boolean
  currentAccountList: CurrentAccountListState
  session: SessionState
}

const CurrentAccountList: React.FC<Props> = ({ currentAccountList, session, fullInfo = true }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation(['current', 'client'])
  const [forceReRead, setForceReRead] = useState<boolean>(false)

  useEffect(() => {
    setForceReRead(false)
    dispatch(fetchCurrentAccounts(history.location.search ? `${history.location.search}&limit=1000` : `?limit=1000`))
  }, [dispatch, history.location.search, forceReRead])

  const initDefaultFilters: Filters = {
    currentAccountFrom: moment().startOf('year').subtract(1, 'years').tz("America/Argentina/Buenos_Aires").format(),
    currentAccountTo: moment().endOf('month').tz("America/Argentina/Buenos_Aires").format(),
  }


  const linkToCurrentAccountDetail = (currentAccount: CurrentAccount) => {
    if (currentAccount.comprobante.includes('CR')) {
      const match = currentAccount.comprobante.match(/^([A-Z]+)\s+(\d+)-(\d+)$/);

      if (match) {
        //const tipo = match[1]; // 'CR'
        const sucursal = match[2];  // '0001'
        const numero = match[3];    // '00002345'

        const detailUrl = `/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/bouncedReceipts/detail/${sucursal}&${numero}`;
        history.push(detailUrl)
      }
    }
    else {
      if (receiptLegalTypes.includes(currentAccount.comprobante.charAt(0))) {
        const detailUrl = `/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/accounts/detail/${currentAccount.comprobante}`
        history.push(detailUrl)
      }
    }
  }

  return (
    <Stack style={{ height: fullInfo ? (isAdmin(session) || isManager(session) || isHeadSales(session) || isVendor(session) || isStaff(session)) ? '' : 'calc(100% - var(--header-height)' : '' }}>
      {fullInfo &&
        (isAdmin(session) || isManager(session) || isHeadSales(session) || isStaff(session)) &&
        <FiltersBar defaultFilters={initDefaultFilters}>
          {/*
          <FilterFromDate name="currentAccountFrom" label={t("fromDate")} />
          <FilterToDate name="currentAccountTo" label={t("toDate")} />
          <FilterTel name="currentAccountNumber" label={t("number")} />
          <FilterReceipts name="receipts" label={t("receipt")} />*/}
          <FilterClientName name="codigo_cliente" label={t('title', { ns: 'client' })} />
        </FiltersBar>}
      <CurrentAccounts
        rows={(currentAccountList.currentAccounts || []).map(s => ({ data: s }))}
        electronicStockRows={(currentAccountList.electronicStock || []).map(s => ({ data: s }))}
        loading={currentAccountList.isFetching}
        fullInfo={fullInfo}
        adminInfo={isAdmin(session) || isManager(session) || isHeadSales(session) || isStaff(session) || isVendor(session)}
        pagination={currentAccountList.pagination || undefined}
        showDownloadButton={true}
        codigo_cliente={session.byPersonTypeId?.toString()}
        onClickInfo={linkToCurrentAccountDetail}
      />
    </Stack>
  )
}

const mapStateToProps = (state: AppState) => ({
  currentAccountList: state.currentAccountList,
  session: state.session
})

export default connect(mapStateToProps, null)(CurrentAccountList)